angular.module('rightPaneModule')
  .controller('ClassroomStandardsController', ['$scope', '$rootScope', '$state', 'classroomApi', 'classroomStandardsApi', 'configuration', 'standard', 'mediaQuery', 'dblAnalyticsProvider', 'customer', 'edxUxPreferenceService', 'edxReportItemService', 'translateFilter', function ($scope, $rootScope, $state, $classroomApi, $classroomStandardsApi, $configuration, $standard, $mediaQuery, $analytics, dblCustomerService, uxPreferenceService, edxReportItemService, translateFilter) {

      $scope.grades = [];
      $scope.domains = [];
      $scope.students = [];
      $scope.standards = [];

      $scope.standardsGridEnabled = $configuration.isFeatureEnabled('standards_grid_enabled');

      $scope.UX_VIEW_KEY = uxPreferenceService.registeredPreferences.classroomStandardsView.key;
      $scope.UX_GRID_VIEW_NAME = uxPreferenceService.registeredPreferences.classroomStandardsView.views.grid;
      $scope.UX_GROUP_VIEW_NAME = uxPreferenceService.registeredPreferences.classroomStandardsView.views.group;

      $scope.treatment1Display = translateFilter('standards.gridView');
      $scope.treatment2Display = translateFilter('standards.groupView');

      var getUxView = function() {
        if (uxPreferenceService.isLoaded()) {
          if ($scope.standardsGridEnabled && $scope._width > $mediaQuery.mobileWidth) {
            return uxPreferenceService.getPreference($scope.UX_VIEW_KEY, $scope.UX_GRID_VIEW_NAME);
          } else {
            return $scope.UX_GROUP_VIEW_NAME;
          }
        } else {
          return '';
        }
      };

      $scope.getUxView = getUxView;

      $scope.exportEnabled = $configuration.isFeatureEnabled('classroom_standards_export_enabled');

      var updateClassroomStandardsExportUrl = function() {
          if ($scope.exportEnabled) {
              $scope.classroomStandardsExportUrl = $classroomApi.getClassroomStandardsExportUrl();
          }
      };

      updateClassroomStandardsExportUrl();

      $scope.gridData = {loadingData: true};
      var updateGridData = function() {
        if ($scope.getUxView() !== $scope.UX_GRID_VIEW_NAME) {
          return;
        }

        $scope.gridData.loadingData = true;
        var params = $standard.getParams();

        $classroomStandardsApi.getClassroomStandardsGrid($state.params.classroomId, params.grade, dblCustomerService.getAcademicStandard().academic_standard_name).then(function(data) {
            $scope.gridData.domains = data.domains;
            $scope.gridData.clusters = data.clusters;
            $scope.gridData.standards = data.standards;
            $scope.gridData.students = data.students;
            $scope.gridData.loadingData = false;
            $scope.gridData.grade = _.findWhere($scope.grades, {id: String(params.grade)});
        });
      };

      var updateGroupData = function() {
          if ($scope.getUxView() !== $scope.UX_GROUP_VIEW_NAME) {
              return;
          }

          var params = $standard.getParams();
          $scope.standards = [];
          $scope.students = [];

          $classroomApi.getClassroomDomains($state.params.classroomId, params.grade).then(function (data) {
              $scope.domains = data.domains;
              $scope.students = data.students;
              $scope.$broadcast('domainsLoaded', data);
              // IN-1199 - when switching from grid to grouping view, we should reload the standards (as we can have a domain selected)
              updateClassroomStandardsData();
          });
      };

      var updateData = function() {
          updateGroupData();
          updateGridData();
      };

      var onViewTypeSelected = function(e) {
        var view = getUxView() === $scope.UX_GRID_VIEW_NAME ? 'grid' : 'group';
        var label = $scope.item.type + '-' + $scope.item.id + "-standards-" + $state.params.standards + "-view-" + view;
        $analytics.eventTrack('Standards View Switched', {category: 'Resource Used', label: label} );

        updateData();
      };

      var updateClassroomGradesData = function () {
          $classroomApi.getClassroomGrades($state.params.classroomId).then(function (data) {
              $scope.grades = data.grades;
              $scope.students = data.students;
              $scope.$broadcast('gradesLoaded', data);
          });
      };

      var updateClassroomDomainsData = function () {
          var params = $standard.getParams();
          if (_.isUndefined(params.grade)) {
              return;
          }

          $scope.viewLevel = '';

          updateData();
      };

      var updateClassroomStudentsStandardsData = function () {
          $scope.disableAssignmentButton = $scope.assignBusy;

          var params = $standard.getParams();

          if (_.isUndefined(params.grade) || _.isUndefined(params.domain) || _.isUndefined(params.standard)) {
              return;
          }

          $classroomApi.getClassroomStudents($state.params.classroomId, params.grade, params.domain, params.standard).then(function (data) {
              $scope.students = data.students;
          });

          $scope.viewLevel = 'STANDARD';
      };

      var updateClassroomStudentsClusterData = function () {
          $scope.disableAssignmentButton = $scope.assignBusy;

          var params = $standard.getParams();
          params.cluster = params.standard;

          if (_.isUndefined(params.grade) || _.isUndefined(params.domain) || _.isUndefined(params.standard)) {
              return;
          }

          $classroomApi.getClassroomStudentsCluster($state.params.classroomId, params.grade, params.domain, params.cluster).then(function (data) {
              $scope.students = data.students;
          });

          $scope.viewLevel = 'CLUSTER';

      };

      var updateClassroomStandardsData = function () {
          var params = $standard.getParams();

          // If there is no grade or domain - clear the standards list.
          $scope.standards = [];

          if (_.isUndefined(params.grade) || _.isUndefined(params.domain)) {
              return;
          }

          // "All Domains" tab
          if(params.domain === 0) {
            updateClassroomStudentsStandardsData();
            return;
          }

          $scope.students = [];

          $classroomApi.getClassroomStandards($state.params.classroomId, params.grade, params.domain).then(function (data) {
            $scope.standards = data.clusters;
              $scope.students = data.students;
              $scope.$broadcast('standardsLoaded', {
                  standards: data
              });
          });

          if(params.domain !== 0) {
              $scope.viewLevel = 'DOMAIN';
          } else {
              $scope.viewLevel = '';
          }
      };

      var initializeData = function (item) {
          $scope.item = item;
          if (!$scope.item) {
              return;
          }

          $classroomApi.getPasswordStyles($state.params.classroomId, function (data) {
              $scope.passwordStyles = data;
          });

          $scope.primaryTeachers = $classroomApi.getPrimaryTeachers();

          updateClassroomGradesData();
      };

      var initializeSubscription = edxReportItemService.getItemObservable().subscribe(function (item) {
          initializeData(item);
      });

      $scope.$on('loadDomains', updateClassroomDomainsData);
      $scope.$on('loadStandards', updateClassroomStandardsData);
      $scope.$on('standardClicked', updateClassroomStudentsStandardsData);
      $scope.$on('clusterClicked', updateClassroomStudentsClusterData);
      $scope.$on('viewTypeSelected', onViewTypeSelected);

      $scope.$on('$destroy', function () {
          initializeSubscription.dispose();
      });

  }]);
